"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecipientActionsTextField = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _reactHookForm = require("react-hook-form");

var RecipientActionsTextField = function RecipientActionsTextField(_ref) {
  var label = _ref.label,
      name = _ref.name,
      control = _ref.control,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled;
  return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    control: control,
    name: name,
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
          value = _ref2$field.value,
          _onChange = _ref2$field.onChange,
          error = _ref2.fieldState.error;
      return /*#__PURE__*/_react.default.createElement(_material.Box, {
        mt: 3,
        ml: 3,
        mb: 3
      }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
        label: label,
        fullWidth: true,
        value: value,
        multiline: true,
        minRows: 4,
        onChange: function onChange(e) {
          return _onChange(e.target.value);
        },
        disabled: disabled,
        variant: "outlined",
        placeholder: placeholder,
        error: Boolean(error),
        helperText: error === null || error === void 0 ? void 0 : error.message,
        inputProps: {
          'data-testid': "SalesIntegration.".concat(name)
        }
      }));
    }
  });
};

exports.RecipientActionsTextField = RecipientActionsTextField;